export default __webpack_public_path__ + "static/media/humidity.a4ee10f7.png";